export function VectorProveLogo({
  height = 16,
  color = '#000000',
}: {
  height?: number;
  color?: string;
}) {
  const aspectRatio = 55 / 16;
  const width = height * aspectRatio;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 55 16"
      fill="none"
    >
      <g clipPath="url(#prove_clip)">
        <mask
          id="prove_mask"
          style={{ maskType: 'luminance' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="55"
          height="16"
        >
          <path d="M54.6841 0.107422H0V15.7103H54.6841V0.107422Z" fill="white" />
        </mask>
        <g mask="url(#prove_mask)">
          <path
            d="M3.28484 5.85724C3.28484 6.76427 2.54943 7.49967 1.64242 7.49967C0.735405 7.49967 0 6.76427 0 5.85724C0 4.95024 0.735405 4.21484 1.64242 4.21484C2.54943 4.21484 3.28484 4.95024 3.28484 5.85724Z"
            fill={color}
          />
          <path
            d="M7.3903 5.85724C7.3903 6.76427 6.6549 7.49967 5.74786 7.49967C4.84087 7.49967 4.10547 6.76427 4.10547 5.85724C4.10547 4.95024 4.84087 4.21484 5.74786 4.21484C6.6549 4.21484 7.3903 4.95024 7.3903 5.85724Z"
            fill={color}
          />
          <path
            d="M3.28484 9.96079C3.28484 10.8678 2.54943 11.6032 1.64242 11.6032C0.735405 11.6032 0 10.8681 0 9.96079C0 9.05376 0.735405 8.31836 1.64242 8.31836C2.54943 8.31836 3.28484 9.05376 3.28484 9.96079Z"
            fill={color}
          />
          <path
            d="M7.3903 9.96079C7.3903 10.8678 6.6549 11.6032 5.74786 11.6032C4.84087 11.6032 4.10547 10.8678 4.10547 9.96079C4.10547 9.05376 4.84087 8.31836 5.74786 8.31836C6.6549 8.31836 7.3903 9.05376 7.3903 9.96079Z"
            fill={color}
          />
          <path
            d="M3.28484 1.74984C3.28484 2.65686 2.54943 3.39226 1.64242 3.39226C0.735405 3.39226 0 2.65686 0 1.74984C0 0.842824 0.735405 0.107422 1.64242 0.107422C2.54943 0.107422 3.28484 0.842824 3.28484 1.74984Z"
            fill={color}
          />
          <path
            d="M7.3903 1.74984C7.3903 2.65686 6.6549 3.39226 5.74786 3.39226C4.84087 3.39226 4.10547 2.65686 4.10547 1.74984C4.10547 0.842824 4.84087 0.107422 5.74786 0.107422C6.6549 0.107422 7.3903 0.842824 7.3903 1.74984Z"
            fill={color}
          />
          <path
            d="M11.4958 1.74984C11.4958 2.65686 10.7604 3.39226 9.85333 3.39226C8.94634 3.39226 8.21094 2.65686 8.21094 1.74984C8.21121 0.842824 8.94634 0.107422 9.85333 0.107422C10.7604 0.107422 11.4958 0.842824 11.4958 1.74984Z"
            fill={color}
          />
          <path
            d="M11.4958 5.85724C11.4958 6.76427 10.7604 7.49967 9.85333 7.49967C8.94634 7.49967 8.21094 6.76427 8.21094 5.85724C8.21094 4.95024 8.94634 4.21484 9.85333 4.21484C10.7604 4.21484 11.4958 4.95024 11.4958 5.85724Z"
            fill={color}
          />
          <path
            d="M3.28484 14.0682C3.28484 14.9752 2.54943 15.7106 1.64242 15.7106C0.735405 15.7106 0 14.9752 0 14.0682C0 13.1612 0.735405 12.4258 1.64242 12.4258C2.54943 12.4258 3.28484 13.1609 3.28484 14.0682Z"
            fill={color}
          />
          <path
            d="M11.4958 9.96079C11.4958 10.8678 10.7604 11.6032 9.85333 11.6032C8.94634 11.6032 8.21094 10.8678 8.21094 9.96079C8.21094 9.05376 8.94634 8.31836 9.85333 8.31836C10.7604 8.31836 11.4958 9.05376 11.4958 9.96079Z"
            fill={color}
          />
          <path
            d="M25.898 3.87173C25.898 5.85955 24.3874 7.41519 22.336 7.41519H19.9347V11.454H18.0742V0.322266H22.336C24.3874 0.322266 25.898 1.91573 25.898 3.87173ZM24.0216 3.87173C24.0216 2.94948 23.3061 2.10339 22.336 2.10339H19.9347V5.63409H22.336C23.3061 5.63382 24.0216 4.80975 24.0216 3.87173Z"
            fill={color}
          />
          <path
            d="M31.2266 3.61472V5.23673C30.9723 5.17311 30.702 5.12552 30.4474 5.12552C29.3185 5.12552 28.3959 5.90469 28.3959 7.30399V11.4542H26.6309V3.67836H28.3959V4.71212C28.8572 3.96475 29.5727 3.51953 30.495 3.51953C30.7335 3.51953 30.9881 3.56713 31.2266 3.61472Z"
            fill={color}
          />
          <path
            d="M39.2398 7.57458C39.2398 9.88033 37.4749 11.6136 35.201 11.6136C32.927 11.6136 31.1777 9.88033 31.1777 7.57458C31.1777 5.26883 32.927 3.51953 35.201 3.51953C37.4749 3.5198 39.2398 5.26883 39.2398 7.57458ZM32.9268 7.57458C32.9268 8.89446 33.9126 9.91216 35.2007 9.91216C36.4887 9.91216 37.4907 8.89446 37.4907 7.57458C37.4907 6.23894 36.4887 5.22097 35.2007 5.22097C33.9126 5.22124 32.9268 6.23894 32.9268 7.57458Z"
            fill={color}
          />
          <path
            d="M43.8217 11.4538H42.295L39.0352 3.67773H40.9594L43.0584 9.08448L45.1417 3.67773H47.0815L43.8217 11.4538Z"
            fill={color}
          />
          <path
            d="M54.6366 7.98798H48.6416C48.8164 9.22844 49.6277 10.0076 50.9473 10.0076C51.9015 10.0076 52.6488 9.56242 52.808 8.89447H54.589C54.3031 10.5323 52.824 11.6136 50.9158 11.6136C48.642 11.6136 46.877 9.8485 46.877 7.52672C46.877 5.26856 48.642 3.51953 50.8842 3.51953C52.9831 3.51953 54.6846 5.12552 54.6846 7.39944C54.6842 7.60641 54.6686 7.82914 54.6366 7.98798ZM52.76 6.6363C52.6488 5.6662 51.8535 4.98244 50.7882 4.98244C49.7389 4.98244 48.9755 5.63437 48.7052 6.6363H52.76Z"
            fill={color}
          />
        </g>
      </g>
      <defs>
        <clipPath id="prove_clip">
          <rect width="55" height="15.9929" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
